/**
 * Calcula el total de etiquetas/aditivos para un producto.
 * Usa etiquetas_extra como fuente autoritativa. Si no existe (0, null, undefined),
 * calcula desde el array de etiquetas multiplicado por la cantidad.
 *
 * @param {Object} producto - { etiquetas_extra, etiquetas, cantidad }
 * @returns {number} Total de etiquetas ya multiplicado por cantidad
 */
export function etiquetaTotal(producto) {
  if (!producto) return 0;
  const extra = producto.etiquetas_extra;
  if (typeof extra === 'number' && extra > 0) return extra;
  const etiquetas = producto.etiquetas || [];
  if (etiquetas.length === 0) return 0;
  const unitSum = etiquetas.reduce((s, e) => s + (e.precio || 0), 0);
  return unitSum * (producto.cantidad || 1);
}

/**
 * Recalcula `etiquetas_extra` (que es un TOTAL ya multiplicado por cantidad)
 * al cambiar la cantidad de un item. Evita que el total quede desactualizado
 * para combos (precio cerrado + extras) y productos con personalizaciones.
 */
export function escalarEtiquetasExtra(item, nuevaCantidad) {
  if (!item) return 0;
  const extra = Number(item.etiquetas_extra) || 0;
  const cant = Number(item.cantidad) || 0;
  if (extra <= 0 || cant <= 0) return 0;
  return (extra / cant) * nuevaCantidad;
}
